import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useParams } from "react-router-dom"
import { FIELD_OFFICER } from "../../../../../constants/InitTypeConstants.js"
import {
  clearDataForecast,
  deleteForecastData,
  getListFoBySubRegional,
  getMitraListSelector,
  initDataForecast,
  submitDataForecast
} from "../../../../../redux/actions/FieldOfficerAction.jsx"
import { fetchPlants } from "../../../../../redux/actions/MasterDataAction.jsx"
import { toast } from "react-toastify"
import { KPI_GOAL_SETTING_TAB } from "../../../../../constants/StringConstant.js"

export function useTableInputForecast2({ month, onAfterSubmit }) {
  const param = useParams()
  const location = useLocation()

  const [targetFO, setTargetFO] = useState(undefined)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [data, setData] = React.useState([])
  const [mitraList, setMitraList] = useState(undefined)
  const [selectedMonth, setSelectedMonth] = useState(undefined)
  const [isMitraListLoading, setMitraListLoading] = useState(true)
  const [isFromHistory, setIsFromHistory] = useState(false)
  const [isInit, setIsInit] = useState(false)
  const dispatch = useDispatch()
  const { FieldOfficer, MasterData, General } = useSelector((state) => state)
  const dataInitForecast = FieldOfficer?.initForecast || []
  const loadingInitForecast = FieldOfficer?.loadingInitForecast
  const { id, year } = param
  const isThisYear = isNaN(Number(year)) && year === KPI_GOAL_SETTING_TAB.THIS_YEAR
  const plantList = MasterData?.plantList || []
  const [search, setSearch] = useState({ keyword: "" })
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const formMitraSearchRef = useRef()
  const dataFo = FieldOfficer?.listFoBySubRegional || []

  useEffect(() => {
    dispatch(clearDataForecast())
    setIsInit(false)
    setData([])
    dispatch(fetchPlants({
      use_metrics: true
    }))
    dispatch(getListFoBySubRegional(id))
  }, [id, year])

  useEffect(() => {
    dispatch(clearDataForecast())
    setIsInit(false)
    setData([])
  }, [month])

  useEffect(() => {
    if (id && year && month > -1) {
      dispatch(
        initDataForecast(
          id,
          isNaN(Number(year)) && year === KPI_GOAL_SETTING_TAB.THIS_YEAR
            ? new Date().getFullYear()
            : year,
          { month: month }
        )
      )
    }
  }, [id, year, month])

  useEffect(() => {
    setLoadingSubmit(
      General?.loading && General.actionInitType === FIELD_OFFICER.SUBMIT_DATA_FORECAST
    )
    setLoadingDelete(
      General?.loading && General.actionInitType === FIELD_OFFICER.DELETE_DATA_FORECAST
    )
  }, [General])

  useEffect(() => {
    const searchString = location.search
    const searchParams = new URLSearchParams(searchString)
    const history = searchParams.get("history")
    setIsFromHistory(!!history)
  }, [location.search])

  useEffect(() => {
    if (typeof targetFO !== "undefined") {
      const monthData = data.find((monthItem) => monthItem.month_number === targetFO.month)
      if (monthData) {
        setSelectedMonth(monthData)
        dispatch(getMitraListSelector(targetFO.fo))
      }
    }
  }, [targetFO, data])

  useEffect(() => {
    setMitraListLoading(true)
    resetMitraSearch()
    if (FieldOfficer.mitraListSelector) {
      let existingMitras = []
      if (selectedMonth) {
        if (targetFO) {
          const foData = selectedMonth.fieldOfficers.find((foItem) => foItem.id === targetFO.fo)
          if (foData) {
            existingMitras = foData.mitras
              .filter((mitraItem) => mitraItem.id !== "")
              .map((mitraFilteredItem) => mitraFilteredItem.mitra_id)
            setMitraList(
              FieldOfficer.mitraListSelector
                .map((mitraListItem) => {
                  return {
                    ...mitraListItem,
                    mitra_id: mitraListItem.id,
                    selected: existingMitras.includes(mitraListItem.id),
                    isAlreadySelected: existingMitras.includes(mitraListItem.id)
                  }
                })
                .sort((first, last) => last.isAlreadySelected - first.isAlreadySelected)
            )
          }
        }
      }
      setMitraListLoading(false)
    }
  }, [FieldOfficer.mitraListSelector])

  function generateRawMitras(isInitial) {
    return [
      {
        id: "",
        name: "",
        seq: 0,
        isInitial,
        forecast: generateForecastData()
      }
    ]
  }

  function generateForecastData() {
    if (plantList && plantList.length > 0) {
      return plantList.map((e) => {
        return {
          plant_type_id: e?.id,
          label: e?.name,
          value: 0
        }
      })
    }
  }

  const getMonthName = (monthNumber) => {
    const months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember"
    ]
    return months[monthNumber]
  }

  useEffect(() => {
    if (isInit) {
      return
    }

    if (dataFo.length > 0 && !loadingInitForecast && plantList.length > 0) {
      const monthNumber = month != null ? month : 1

      const generatedData = [{
        month_number: monthNumber,
        name: getMonthName(monthNumber),
        fieldOfficers: dataFo.map((fo) => ({
          id: fo.id,
          name: fo.name,
          mitras: generateRawMitras(true)
        }))
      }]

      setData(generatedData)
    } else if (dataFo.length === 0 && !isInit) {
      setData([])
    }
  }, [dataFo, loadingInitForecast, dataInitForecast, isInit, month, plantList])

  useEffect(() => {
    if (!isInit &&
      dataInitForecast?.length > 0 &&
      data.length > 0 &&
      !loadingInitForecast &&
      plantList?.length > 0) {
      handleInitForecast()
      setIsInit(true)
    }
  }, [dataInitForecast, data, loadingInitForecast, plantList, isInit])

  function handleInitForecast() {
    if (!dataInitForecast || dataInitForecast.length === 0) return

    const updatedData = data.map((monthData) => {
      const updatedFieldOfficers = monthData.fieldOfficers.map((fo) => {
        const relatedForecasts = dataInitForecast.filter(
          (entry) => entry.fo_id === fo.id
        )

        const mitraMap = new Map()

        fo.mitras
          .filter(mitra => mitra.id !== "")
          .forEach((mitra) => {
            mitraMap.set(mitra.mitra_id, mitra)
          })

        relatedForecasts.forEach((e) => {
          if (!mitraMap.has(e.mitra_id)) {
            mitraMap.set(e.mitra_id, {
              id: e.id,
              mitra_id: e.mitra_id,
              name: e.mitra_name,
              seq: 0,
              isInitial: false,
              forecast: plantList.map((plantItem) => {
                const foundForecast = e.forecast.find((f) => f.plant_type_id === plantItem.id)
                return {
                  plant_type_id: plantItem.id,
                  label: plantItem.name,
                  value: foundForecast && foundForecast.value !== undefined ? foundForecast.value : 0
                }
              }) || []
            })
          }
        })

        const updatedMitras = Array.from(mitraMap.values())

        updatedMitras.forEach((mitra, index) => {
          mitra.seq = index + 1
        })

        if (updatedMitras.length === 0) {
          updatedMitras.push(...generateRawMitras(true))
        }

        return { ...fo, mitras: updatedMitras }
      })

      return { ...monthData, fieldOfficers: updatedFieldOfficers }
    })

    setData(updatedData)
  }

  function handleAddMitra() {
    const monthId = targetFO?.month
    const foId = targetFO?.fo
    if (mitraList.filter((mitra) => mitra.selected).length === 0) {
      setMitraList(undefined)
      setTargetFO(undefined)
      return
    }

    setData((prevData) =>
      prevData.map((prevMonth) => {
        if (prevMonth.month_number === monthId) {
          return {
            ...prevMonth,
            fieldOfficers: prevMonth.fieldOfficers.map((prevFO) => {
              if (prevFO.id === foId) {
                const existingMitraIds = new Set(
                  prevFO.mitras
                    .filter(m => m.mitra_id && m.mitra_id !== "")
                    .map(m => m.mitra_id)
                )

                const nonEmptyMitras = prevFO.mitras.filter(m => m.id !== "")
                const nextSeq = nonEmptyMitras.length > 0
                  ? Math.max(...nonEmptyMitras.map(m => m.seq)) + 1
                  : 1

                const newMitras = mitraList
                  .filter((mitraListItem) => mitraListItem.selected)
                  .filter((mitraListItem) => !existingMitraIds.has(mitraListItem.id))
                  .map((mitra, index) => {
                    return {
                      ...mitra,
                      seq: nextSeq + index,
                      forecast: generateForecastData()
                    }
                  })

                return {
                  ...prevFO,
                  mitras: nonEmptyMitras.length > 0
                    ? [...nonEmptyMitras, ...newMitras]
                    : newMitras.length > 0
                      ? newMitras
                      : generateRawMitras(true)
                }
              } else {
                return prevFO
              }
            })
          }
        } else {
          return prevMonth
        }
      })
    )

    setMitraList(undefined)
    setTargetFO(undefined)
  }

  const onMitraCheckChange = (_event, mitraListItem) => {
    if (!mitraListItem.isAlreadySelected) {
      setMitraList((mitraCheck) => {
        return mitraCheck.map((mitraCheckItem) => {
          if (mitraCheckItem.id === mitraListItem.id) {
            return { ...mitraCheckItem, selected: !mitraCheckItem.selected }
          } else {
            return mitraCheckItem
          }
        })
      })
    }
  }

  function onChangeValue(e, v, isBlur) {
    const newValue = parseFloat(e?.target?.value || "0")
    const monthNumber = v?.month?.month_number
    const fieldOfficerId = v?.fo
    const mitraId = v?.mitra?.mitra_id
    const plantTypeId = v.key
    let mitraEdited = undefined

    const parseData = data.map((monthItem) => {
      if (monthItem.month_number !== monthNumber) return monthItem
      return {
        ...monthItem,
        fieldOfficers: monthItem.fieldOfficers.map((fo) => {
          if (fo.id !== fieldOfficerId) return fo
          return {
            ...fo,
            mitras: fo.mitras.map((mitra) => {
              if (mitra.mitra_id !== mitraId) return mitra

              const newMitra = {
                ...mitra,
                forecast: mitra.forecast.map((f) =>
                  f.plant_type_id === plantTypeId ? { ...f, value: newValue } : f
                )
              }
              mitraEdited = newMitra
              return newMitra
            })
          }
        })
      }
    })
    setData(parseData)
    if (isBlur) {
      if (mitraEdited.mitra_id) {
        const payloadData = {
          month_number: monthNumber,
          year:
            isNaN(Number(year)) && year === KPI_GOAL_SETTING_TAB.THIS_YEAR
              ? new Date().getFullYear()
              : year,
          sub_regional_id: id,
          fo_id: fieldOfficerId,
          mitra_id: mitraEdited.mitra_id,
          mitra_seq: mitraEdited?.seq,
          forecast: mitraEdited?.forecast
        }
        dispatch(submitDataForecast(payloadData))
        .then(() => {
          if (onAfterSubmit) {
            onAfterSubmit()
          }
        })
      } else {
        toast.error("Terdapat Parameter yang kosong")
      }
    }
  }

  const onMitraSearch = (value) => {
    setSearch({ keyword: value.keyword })
    setIsActiveSearch(true)
  }

  const resetMitraSearch = () => {
    setSearch({ keyword: "" })
    setIsActiveSearch(false)
  }

  const removeMitraFromFO = (monthNumber, foId, mitraId, forecastId = undefined) => {
    setData((prevData) =>
      prevData.map((prevMonth) => {
        if (prevMonth.month_number === monthNumber) {
          return {
            ...prevMonth,
            fieldOfficers: prevMonth.fieldOfficers.map((prevFO) => {
              if (prevFO.id === foId) {
                if (typeof forecastId !== "undefined") {
                  dispatch(deleteForecastData(forecastId))
                }

                const filteredMitras = prevFO.mitras.filter((prevMitra) => prevMitra.id !== forecastId)

                const updatedMitras = filteredMitras.length === 0
                  ? generateRawMitras(true)
                  : filteredMitras

                return {
                  ...prevFO,
                  mitras: updatedMitras
                }
              } else {
                return prevFO
              }
            })
          }
        } else {
          return prevMonth
        }
      })
    )
  }

  useEffect(() => {
    if (formMitraSearchRef.current) {
      if (formMitraSearchRef.current?.values?.keyword === "") resetMitraSearch()
    }
  }, [formMitraSearchRef.current?.values])

  function checkDisableInputForecast(year, disable) {
    if (disable) {
      return true
    } else {
      return isFromHistory
    }
  }

  const sumDataMitras = React.useMemo(() => {
    return (fo) => {
      const forecast = (fo.mitras || []).map((e) => e?.forecast)
      const resultMap = new Map()

      forecast.flat().forEach((item) => {
        if (!item?.plant_type_id) return
        if (!resultMap.has(item.plant_type_id)) {
          resultMap.set(item.plant_type_id, { ...item })
        } else {
          resultMap.get(item.plant_type_id).value += item.value
        }
      })

      return Array.from(resultMap.values())
    }
  }, [data])

  // Sum total per plant type across all FOs for the current month
  const plantTypeTotals = React.useMemo(() => {
    if (data.length === 0) return {}
    const monthData = data[0]
    const totals = {}

    ;(monthData?.fieldOfficers || []).forEach((fo) => {
      const foTotals = sumDataMitras(fo)
      foTotals.forEach((item) => {
        if (!totals[item.plant_type_id]) {
          totals[item.plant_type_id] = 0
        }
        totals[item.plant_type_id] += item.value || 0
      })
    })

    return totals
  }, [data, sumDataMitras])

  // Total forecast for the month (sum of all plant type totals)
  const totalForecastMonth = React.useMemo(() => {
    return Object.values(plantTypeTotals).reduce((sum, val) => sum + val, 0)
  }, [plantTypeTotals])

  // Current month data (single month)
  const monthData = data.length > 0 ? data[0] : null

  return {
    data,
    setData,
    monthData,
    handleAddMitra,
    sumDataMitras,
    loadingSubmit,
    onChangeValue,
    targetFO,
    setTargetFO,
    mitraList,
    onMitraCheckChange,
    isMitraListLoading,
    setSearch,
    search,
    isActiveSearch,
    setIsActiveSearch,
    formMitraSearchRef,
    resetMitraSearch,
    onMitraSearch,
    removeMitraFromFO,
    loadingDelete,
    year,
    checkDisableInputForecast,
    isFromHistory,
    isThisYear,
    loadingInitForecast,
    plantList,
    plantTypeTotals,
    totalForecastMonth,
    getMonthName
  }
}
